var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWatch = function SvgIconWatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 9a1 1 0 1 0-2 0v3a1 1 0 0 0 1 1h3a1 1 0 1 0 0-2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.646.5h4.708a1.75 1.75 0 0 1 1.728 1.486v.002l.592 3.83A7.74 7.74 0 0 1 19.75 12a7.74 7.74 0 0 1-3.076 6.182l-.592 3.83v.002a1.75 1.75 0 0 1-1.728 1.486H9.645a1.75 1.75 0 0 1-1.728-1.486v-.001l-.592-3.83A7.74 7.74 0 0 1 4.25 12a7.74 7.74 0 0 1 3.076-6.182l.592-3.83v-.002A1.75 1.75 0 0 1 9.646.5M9.53 19.348l.332 2.152h4.276l.332-2.152a7.7 7.7 0 0 1-2.47.402 7.7 7.7 0 0 1-2.47-.402M14.138 2.5l.332 2.152A7.7 7.7 0 0 0 12 4.25c-.864 0-1.694.141-2.47.402L9.862 2.5zM6.25 12a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0",
    clipRule: "evenodd"
  }))));
};
export default SvgIconWatch;